import { apiWrapper, apiCancel } from '../../wrapper'

export const initial = 'HukumanDisiplin'
const baseUrl = process.env.REACT_APP_SERVICE_CORE_URL
const appCode = process.env.REACT_APP_SERVICE_CORE_APPCODE
const outputType = 'json'

export const HDlist = 'Kepegawaian/HukumanDisiplin/list/'
export const HDdetail = 'Kepegawaian/HukumanDisiplin/detail/'
export const HDCreateSP = 'Kepegawaian/HukumanDisiplin/createSP/'
export const HDUpdate = 'Kepegawaian/HukumanDisiplin/update/'
export const HDDownloadSP = 'Kepegawaian/HukumanDisiplin/downloadDraftSP/'
export const HDUploadHasil = 'Kepegawaian/HukumanDisiplin/UploadHasil/'
export const HDUploadSK = 'Kepegawaian/HukumanDisiplin/UploadSK/'

export const HDlistHistory = 'Kepegawaian/HukumanDisiplin/listHistory/'
export const masterPunishment = 'Master/List/punishment/'
export const PegawaiEmployeeList = 'Kepegawaian/Presensi/employeeList/'
export const HukdisList = 'Kepegawaian/HukumanDisiplin/listhukuman/'
export const HDCreateManual = 'Kepegawaian/Hukdis/prosesPegawaiManual/'

//export const cancelToken = () => apiCancel
export const cancelToken = () => {
    return apiCancel()
}
export const apiRequest = async (method, route, data = { params: null, body: null, cancelToken: null }, needToken=true) => {
    if(needToken) {
        const thisTime = (Math.floor(Date.now()/1000))
        const expire = localStorage.getItem(initial + 'accessExpired')
        if(expire < thisTime) {
           await apiWrapper(baseUrl, initial, appCode, outputType, 'post', 'auth/getAccessToken/', data)
           .then(result => {
                localStorage.setItem(initial + 'accessToken', result.response.access_token)
                return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
            })
            .catch(result => {
                return Promise.reject('Tidak dapat mengambil accessToken');
            })
        } else {
            return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)        
        }
    }
    return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
}